/**
 * RedirectHandler_v2.js
 * Исправляет уязвимость V17 (Open Redirect через параметр ?next=)
 * и V18 (SSO-токен в URL виден в истории браузера).
 *
 * ИЗМЕНЕНИЯ vs оригинального RedirectHandler.js:
 * 1. ?next= валидируется — допустимы только относительные пути нашего приложения
 * 2. SSO-токен немедленно обменивается на сессионный токен (/v2/auth/verify_sso.php)
 * 3. После обмена токен убирается из URL через replaceState — не остаётся в истории
 * 4. user_id не хранится в localStorage — только session_token
 */

import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { verifySsoToken } from "./api_v2/auth";
import { useAppV2 } from "./context_v2/AppContext_v2";

/** Белый список допустимых маршрутов приложения для параметра ?next= */
const ALLOWED_PATHS = [
  "/subscription",
  "/profile",
  "/tasks",
  "/notes",
  "/graph",
  "/downloads",
  "/social-download",
  "/links",
];

/**
 * Проверяет что путь безопасен для редиректа:
 * — только относительный путь (не начинается с // или http)
 * — начинается с /
 * — входит в список разрешённых маршрутов
 */
function isSafePath(path) {
  if (!path || typeof path !== "string") return false;
  if (path.startsWith("//") || path.startsWith("http")) return false;
  if (!path.startsWith("/")) return false;
  // Разрешаем точные совпадения или вложенные пути разрешённых маршрутов
  return ALLOWED_PATHS.some(
    (allowed) => path === allowed || path.startsWith(allowed + "/")
  );
}

export default function RedirectHandlerV2({ onLogin }) {
  const nav = useNavigate();
  const loc = useLocation();
  const { refreshUser } = useAppV2();

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const ssoToken = params.get("token");
    const rawNext = params.get("next");

    // Валидируем next — только разрешённые пути
    const next = isSafePath(rawNext) ? rawNext : "/subscription";

    if (!ssoToken) {
      nav("/register", { replace: true });
      return;
    }

    // Немедленно убираем токен из URL (до запроса к серверу)
    // Это предотвращает утечку SSO-токена в истории браузера
    const cleanUrl = window.location.pathname;
    window.history.replaceState(null, "", cleanUrl);

    verifySsoToken(ssoToken)
      .then(async (result) => {
        if (!result.success) throw new Error("invalid sso token");

        // Обновить контекст пользователя с сервера
        await refreshUser();
        onLogin?.(result.user);
        nav(next, { replace: true });
      })
      .catch(() => {
        nav("/register", { replace: true });
      });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <p style={{ textAlign: "center" }}>Авторизуем&nbsp;вас…</p>;
}
